import React from "react";
import { LegalPage, Sec, Ul, COMPANY } from "@/components/legal/LegalLayout";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" testid="privacy-page">
      <p>This Privacy Policy explains how {COMPANY} (“we”, “us”), the operator of Hat Trick (hat-trick.cc, including the Hat Trick NHL, First Bucket NBA and Green Ball tennis dashboards), collects, uses and protects information when you use the service.</p>

      <Sec n={1} title="Information we collect">
        <p><strong className="text-white">Information you give us</strong></p>
        <Ul items={[
          "Account details: your name (optional), email address and password. Passwords are stored only as a one-way hash, never in readable form.",
          "Google sign-in: if you choose “Continue with Google”, we receive your name, email address and profile picture from the sign-in provider.",
          "AI assistant: the questions you type into the in-app AI assistant and the replies it generates.",
        ]} />
        <p><strong className="text-white">Information collected automatically</strong></p>
        <Ul items={[
          "Sign-in sessions: secure cookies that keep you logged in, and a session record (account ID and expiry) on our servers.",
          "Basic technical data our hosting provider records when your browser requests a page, such as IP address, browser type and time of request.",
        ]} />
        <p><strong className="text-white">Information stored only on your device</strong></p>
        <Ul items={["Your player tracker list is saved in your browser’s local storage and is not sent to our servers."]} />
        <p>We do not collect payment information. Hat Trick is currently free, and no paid plan is on sale.</p>
      </Sec>

      <Sec n={2} title="How we use information">
        <Ul items={[
          "To create and secure your account, keep you signed in and let you reset your password.",
          "To provide the dashboards, the AI assistant and other features you request.",
          "To show aggregate, anonymous platform counts (for example, the number of registered and currently active accounts).",
          "To maintain, debug and improve the service and protect it against abuse.",
          "To comply with legal obligations.",
        ]} />
        <p>We do not sell your personal information, and we do not use it for third-party advertising.</p>
      </Sec>

      <Sec n={3} title="Service providers">
        <p>We share information only with providers that help us run Hat Trick, and only as needed for that purpose:</p>
        <Ul items={[
          "Hosting and database infrastructure that stores account and session data.",
          "The Google sign-in provider, if you choose to sign in with Google.",
          "AI model providers that process your AI-assistant messages to generate replies.",
        ]} />
        <p>Sports statistics, schedules and odds shown in the dashboards come from public sports data sources; we do not send your personal information to them.</p>
        <p>We may also disclose information if required by law, to protect our rights or users’ safety, or as part of a merger, acquisition or sale of the business.</p>
      </Sec>

      <Sec n={4} title="Cookies">
        <p>We use essential cookies only, to keep you signed in and to protect your session. We do not use advertising or cross-site tracking cookies. Blocking cookies will prevent you from signing in.</p>
      </Sec>

      <Sec n={5} title="Retention">
        <p>We keep account information while your account is active. Session records expire automatically. You may ask us to delete your account and its associated data at any time; we will do so unless we must keep certain information to meet a legal obligation.</p>
      </Sec>

      <Sec n={6} title="Your rights">
        <p>Depending on where you live (including under applicable U.S. state privacy laws and Canada’s PIPEDA and provincial laws), you may have the right to access, correct or delete your personal information, to withdraw consent, and to complain to a data-protection authority. To make a request, contact us as described below. We will not discriminate against you for exercising these rights.</p>
      </Sec>

      <Sec n={7} title="Security">
        <p>We use reasonable safeguards, including hashed passwords, secure HTTP-only session cookies and encrypted connections. No method of transmission or storage is completely secure, so we cannot guarantee absolute security.</p>
      </Sec>

      <Sec n={8} title="Age requirement">
        <p>Hat Trick is intended only for people who have reached the legal age for sports wagering where they live. We do not knowingly collect information from anyone below that age or from children under 13. If you believe such a person has created an account, contact us and we will delete it.</p>
      </Sec>

      <Sec n={9} title="International users">
        <p>Hat Trick is operated for users in the United States and Canada. Your information may be stored and processed in either country, or wherever our service providers operate.</p>
      </Sec>

      <Sec n={10} title="Changes to this policy">
        <p>We may update this policy from time to time. We will change the effective date above and, for material changes, give notice in the app.</p>
      </Sec>

      <Sec n={11} title="Contact">
        <p>For privacy questions or requests, contact {COMPANY} through the Hat Trick app while signed in, or through the contact channel listed on hat-trick.cc.</p>
      </Sec>
    </LegalPage>
  );
}
